import '../styles/page_about.scss';

function PageAbout() {

	return (
		<div className="page page_about">
			<h2 className="title2">About</h2>
			<ul>

				<li>Datapod is an open-source framework based on create-react-app which enables you to build data-driven websites fast</li>
				<li>Datapod is being developed by <a href="http://tanguay.info">Edward Tanguay</a></li>
				<li>View the code and join the project at <a href="https://github.com/Entwickler-Club/dpodreact">GitHub</a></li>
			</ul>
		</div>
	)
}

export default PageAbout;